/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DashboardEEComponents.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CustomDataGridV2 from "../../../common/datagrid/CustomDataGridV2";
import { componentStyle } from "../../../../../config/appTheme";
import { useNavigate } from "react-router-dom";

function DashboardEEComponents({
  recentActivitiesDetails,
  getUserFullNameById,
}) {

  const navigate = useNavigate();
  const [eeCTableRowsData, setEECTableRowsData] = useState([]);
  const [enableMore, setEnableMore] = useState(false);

  useEffect(() => {
    const eeComponentDetails = recentActivitiesDetails?.eeComponentDetails || [];
    setEnableMore(eeComponentDetails.length > 5);
    const filteredeeComponentDetails = [...eeComponentDetails]
      .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
      .slice(0, 5)
      .map((item) => ({
        id: item?.ee_id,
        assembly_number: item?.assembly_number,
        supplier_name: item?.supplier_name,
        description: item?.description,
        version: item?.version,
        created_by: item?.owner_details?.[0]?.name,
        updated_at: item?.updated_at,
        allData: item,
      }));

    setEECTableRowsData(filteredeeComponentDetails);
  }, [recentActivitiesDetails]);

  const EE_COLUMNS = [
    {
      field: "assembly_number",
      headerName: "Assembly Number",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "supplier_name",
      headerName: "Supplier Name",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "version",
      headerName: "Version",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "created_by",
      headerName: "Owner",
      width: 140,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {getUserFullNameById(params?.value || "-")}
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ height: "450px", width: "100%" }}>
      <CustomDataGridV2
        columns={EE_COLUMNS}
        rows={eeCTableRowsData}
        enableMore={enableMore}
        handleMore={() => {
          navigate("/dashboard/v2/EESWM");
        }}
      />
    </Box>
  );
}

DashboardEEComponents.propTypes = {
  recentActivitiesDetails: PropTypes.shape({
    eeComponentDetails: PropTypes.array,
  }),
  getUserFullNameById: PropTypes.func,
};

export default DashboardEEComponents;
